import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { InviteLinkField } from 'components/leagues/InviteLinkField';
import { useLeagueInviteLink } from 'components/leagues/useLeagueInviteLink';

const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  background-color: var(--c-neutral-300);
  border-radius: var(--double-unit);
  padding: var(--double-unit) var(--double-unit);
  color: var(--c-neutral-1000);
  font-weight: var(--t-bold);
  overflow: hidden;

  @media ${tabletAndAbove} {
    padding: var(--double-unit) var(--quadruple-unit);
  }

  --fan-wrapper-width: calc(8 * var(--unit));
  --fan-element-width: calc(5 * var(--unit));
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: var(--double-unit);

  @media ${tabletAndAbove} {
    gap: calc(3 * var(--unit));
  }
`;

const Icon = styled.div`
  padding: var(--douple-unit);
`;

const Column = styled(Vertical)`
  overflow: hidden;
`;

const Label = styled.h1`
  font: var(--t-16);
  font-weight: var(--t-bold);
  padding: 0 var(--unit);
`;

type Props = { leagueSlug: string; inviteRoute: string; icon: ReactNode };

export const InviteLinkBanner = ({ leagueSlug, inviteRoute, icon }: Props) => {
  const inviteLink = useLeagueInviteLink(inviteRoute, leagueSlug);

  return (
    <Wrapper>
      <Row>
        <Icon>{icon}</Icon>
        <Column>
          <Label>
            <FormattedMessage
              id="USSports.InviteLinkBanner.title"
              defaultMessage="Invite a friend"
            />
          </Label>
          <InviteLinkField inviteLink={inviteLink} />
        </Column>
      </Row>
    </Wrapper>
  );
};
